import { toRem, toRems } from "../../helpers/theme";

/* eslint-disable quote-props, no-dupe-keys */
const style = ({ theme, severity }) => ({
    display: "flex",
    position: "relative",
    margin: 0,
    padding: toRems([4, 12]),
    backgroundColor: theme.colors.notice[severity]?.background || "#f2f2f2",
    color: theme.colors.notice[severity]?.text,
    WebkitTapHighlightColor: "transparent",
    [theme.breakpoints.up("md")]: {
        padding: toRems([6, 15]),
        borderRadius: toRem(8),
    },
    "& .noticeIcon": {
        display: "flex",
        flexShrink: 0,
        padding: toRems([7, 0]),
        marginRight: toRem(12),
        fontSize: toRem(25),
        [theme.breakpoints.up("md")]: {
            marginRight: toRem(20),
            fontSize: toRem(40),
        },
        svg: {
            "& path:first-of-type": {
                // this relies on icon having 2 paths
                fill: "currentColor",
            },
        },
    },
    "& .noticeContent": {
        padding: toRems([8, 0]),
    },
    "& .noticeContent_default": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        fontWeight: theme.typography.fontWeight.bold,
        fontSize: toRem(14),
        lineHeight: 1.2,
        [theme.breakpoints.up("md")]: {
            fontSize: toRem(16),
        },
        "&:only-child": {
            height: "100%",
        },
        p: {
            fontSize: "inherit",
            lineHeight: "inherit",
        },
    },
    "& .noticeTitle": {
        margin: toRems([-2, 0, 6, 0]),
        fontWeight: theme.typography.fontWeight.black,
        fontSize: toRem(16),
        [theme.breakpoints.up("md")]: {
            fontSize: toRem(18),
        },
        "&:only-child": {
            margin: 0,
        },
    },
    "& .noticeMessage": {},
    "& .noticeAction": {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: toRem(-8),
        paddingLeft: toRem(16),
    },
    "& .noticeAction_btn": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        verticalAlign: "middle",
        position: "relative",
        margin: 0,
        padding: toRem(3),
        border: 0,
        borderRadius: 0,
        backgroundColor: "transparent",
        color: "inherit",
        fontSize: toRem(18),
        textAlign: "center",
        textDecoration: "none",
        outline: "none",
        cursor: "pointer",
        userSelect: "none",
        MozAppearance: "none",
        WebkitAppearance: "none",
        WebkitTapHighlightColor: "transparent",
        svg: {
            path: {
                fill: "currentColor",
            },
        },
    },
});

export default style;
